var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAegon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1046.25 377.31",
    width: 1046.25,
    height: 377.31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#040506;}"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212",
    transform: "translate(-151.75,-351.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_359",
    "data-name": "Trazado 359",
    className: "cls-1",
    d: "m 433.64,351.87 -281.89,93.4 92.94,283.91 248,-81.72 -21.35,-67.8 -78.67,-0.19 -8.45,31.23 -41,-0.13 67.47,-201 h 42.21 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_360",
    "data-name": "Trazado 360",
    className: "cls-1",
    d: "m 403.11,546 28,-88.93 29.37,89.2 z M 623.43,411.27 H 484.62 v 92.23 l 35.29,105.77 H 630.08 V 575.06 H 520.23 v -55.27 h 78.11 v -33.1 H 520.23 V 444.31 H 623.5 v -33.09 z m 418.46,197.86 V 411.27 h 36.24 l 83.63,131.09 v -131 H 1198 v 197.77 h -35.8 L 1078.06,476 v 133.13 z m -500,69.66 -7.37,-20.52 h 542.62 v 20.52 z M 805.75,460.57 775,476.38 a 75.22,75.22 0 0 0 -18.81,-27 57,57 0 0 0 -31.39,-10.38 50.41,50.41 0 0 0 -39.68,20.42 86.15,86.15 0 0 0 -15,51.63 80,80 0 0 0 15.8,50.47 52.37,52.37 0 0 0 73.81,6.13 c 0.57,-0.49 1.14,-1 1.7,-1.51 a 48.83,48.83 0 0 0 14.69,-30.65 h -48.84 v -34 H 807 v 106.68 h -30.1 v -17.73 a 44.93,44.93 0 0 1 -20.51,16.56 71.42,71.42 0 0 1 -32.34,6.56 81.28,81.28 0 0 1 -65,-28.66 111.87,111.87 0 0 1 -25.08,-76 100.3,100.3 0 0 1 25.03,-71.9 87.1,87.1 0 0 1 67,-29.67 85.77,85.77 0 0 1 55.85,20 103.74,103.74 0 0 1 23.95,33.12 z m 186,-27.07 a 96.44,96.44 0 0 0 -135.92,0 125.18,125.18 0 0 0 0,150.63 96.6,96.6 0 0 0 136,0 124.88,124.88 0 0 0 0,-150.51 z m -27.08,126.1 a 49.17,49.17 0 0 1 -40.78,18.66 50.24,50.24 0 0 1 -41.37,-18.45 93.84,93.84 0 0 1 0.67,-102.49 52.25,52.25 0 0 1 80.89,1.68 74.33,74.33 0 0 1 15.65,49.46 79.53,79.53 0 0 1 -15.06,51.08 z",
    style: {
      fill: "#040506"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAegon);
export default __webpack_public_path__ + "static/media/aegon.dd5361d89bda4236b6a7bd8b67a07949.svg";
export { ForwardRef as ReactComponent };